import { render } from "./SubscriptionExtensionDialog.vue?vue&type=template&id=55f0e6a1"
import script from "./SubscriptionExtensionDialog.vue?vue&type=script&lang=js"
export * from "./SubscriptionExtensionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__